import React, { FC, useMemo } from 'react';

import { ScoreData } from 'src/apps/dashboard/services/queries/score/helpers/transformResults';

import { AccessibilityTrendsChart } from './AccessibilityTrendsChart';
import { AccessibilityScoreData } from './types';

interface AccessibilityTrendsChartContainerProps {
	scoreData?: ScoreData[];
	isLoading?: boolean;
	error?: unknown;
}

export const AccessibilityTrendsChartContainer: FC<AccessibilityTrendsChartContainerProps> = ({
	scoreData,
	isLoading = false,
	error
}) => {
	const chartData = useMemo<AccessibilityScoreData[] | null>(() => {
		if (!scoreData || scoreData.length === 0) {
			return null;
		}

		return scoreData
			.filter((score) => score.score !== null && score.calculation_date)
			.map((score) => ({
				date: score.calculation_date,
				score: Math.round(score.score ?? 0) // Ensure integer values for y-axis
			}))
			.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
	}, [scoreData]);

	return (
		<AccessibilityTrendsChart
			data={chartData}
			isLoading={isLoading}
			error={error ? 'Failed to load accessibility trends data' : null}
			className="accessibility-trends-chart"
		/>
	);
};
